
import { Component, Vue } from 'vue-property-decorator';
import Menu from './menu.vue';
import Main from '@/component/layout/main.vue';
import submenuList from '@/module/submenu.list.data';
import storage from 'baimahu/storage';
@Component({
  components: {
    Menu,
    Main,
  },
})
export default class RuanMain extends Vue {
  visible = false;
  title = '';
  color_list = ['#2891de', '#ff8c1b', '#00b7b1'];
  submenu_list = submenuList;
  user_info = storage.getItem('profile');

  created() {
    if (this.$route.path.includes('hundun')) {
      this.title = '混沌系统';
    } else if (this.$route.path.includes('/limit/')) {
      this.title = '权限管理';
    } else {
      this.title = '整体软装';
    }
  }
  onClose(): void {
    this.visible = false;
  }
}
